// extracted by mini-css-extract-plugin
export var boldText = "_31-4";
export var checkboxContainer = "_31-6";
export var closeIcon = "_31-g";
export var container = "_31-0";
export var drawer = "_31-8";
export var drawerContent = "_31-9";
export var extraSmallText = "_31-5";
export var fulfillmentGroupTable = "_31-e";
export var largeText = "_31-3";
export var loadingSpinnerContainer = "_31-h";
export var mediumText = "_31-2";
export var narrow = "_31-f";
export var notificationLink = "_31-j";
export var packageCheckIconContainer = "_31-7";
export var slideoutHeaderContainer = "_31-a";
export var slideoutModal = "_31-c";
export var stickyHeaderWrapper = "_31-b";
export var table = "_31-i";
export var tableContainer = "_31-d";
export var tertiaryText = "_31-1";